jQuery(function ($) {
  if ($('.user-status__input').length > 0) {
    var sheet = document.createElement('style'),
      $rangeInput = $('.user-status__input'),
      prefs = ['webkit-slider-runnable-track', 'moz-range-track', 'ms-track'],
      thumbs = ['webkit-slider-thumb', 'moz-range-thumb', 'ms-thumb'];

    document.body.appendChild(sheet);

    var getTrackStyle = function (el) {
      var curVal = el.value,
        val = curVal * 33.333333334,
        style = '';

      if(curVal == 2) {
        $('.valid-until').show();
      } else {
        $('.valid-until').hide();
      }

      // Set active label
      $('.user-status__labels li').removeClass('active selected');

      var curLabel = $('.user-status__labels').find('li[data-index="' + curVal + '"]');

      curLabel.addClass('active selected');
      curLabel.prevAll().addClass('selected');

      var color = "#FF5722";
      switch(curVal) {
        case "0":
          color = "#F44336";
          break;
        case "1":
          color = "#FF5722";
          break;
        case "2":
          color = "#4CAF50";
          break;
        case "3":
          color = "#000";
          break;
      }

      // Change range style
      style += '.user-status__labels .active{color: ' + color + '}';
      style += '.user-status__labels .selected::before{background: ' + color + '}';

      for (var i = 0; i < prefs.length; i++) {
        style += '.user-status__input::-' + prefs[i] + '{background: linear-gradient(to right, ' + color + ' 0%, ' + color + ' ' + val + '%, #b2b2b2 ' + val + '%, #b2b2b2 100%)}';
      }
      for (var i = 0; i < thumbs.length; i++) {
        style += '.user-status__input::-' + thumbs[i] + '{background: ' + color + ' !important}';
      }

      return style;
    }

    var storeStatus = function (status_val, user_id) {

      let $form = $('#your-profile');
      $.ajax({
        url: kreenoot_child.ajax_url,
        method: "POST",
        data: {
          action: 'change_user_status',
          user_id: user_id,
          user_status: status_val,
        },
        beforeSend: function () {
          $('.user-status').parent().find('.kl-alert').remove();
          $form.find('button').prop('disabled', true);
        }
      }).success(function (response) {

        if (response.success) {
          $(`<div class="kl-alert alert-success" role="alert">${response.data}</div>`).insertBefore($('.user-status'));
        } else {
          $(`<div class="kl-alert alert-danger" role="alert">${response.data}</div>`).insertBefore($('.user-status'));
        }

        if(status_val != 2 ) {
          $('.valid-until input').val('');
          storeUntilDate(false);
        }

        $form.find('button').prop('disabled', false);

        setTimeout(function () {
          $('.user-status').parent().find('.kl-alert').remove();
        }, 2500)
      });
    }

    function storeUntilDate(notify = true) {

      let $form = $('#your-profile');
      $.ajax({
        url: kreenoot_child.ajax_url,
        method: "POST",
        data: {
          action: 'change_user_valid_until',
          user_id: $('#user_id').val(),
          valid_until: $('.valid-until input').val(),
        },
        beforeSend: function () {
          if(notify) {
            $('.user-status').parent().find('.kl-alert').remove();
            $('.valid-until .button').addClass('button-primary-disabled');
          }
        }
      }).success(function (response) {
        if(notify) {
          if (response.success) {
            $(`<div class="kl-alert alert-success" role="alert">${response.data}</div>`).insertBefore($('.user-status'));
          } else {
            $(`<div class="kl-alert alert-danger" role="alert">${response.data}</div>`).insertBefore($('.user-status'));
          }

          $('.valid-until .button').removeClass('button-primary-disabled');
  
          setTimeout(function () {
            $('.user-status').parent().find('.kl-alert').remove();
          }, 2500)
        }
      });
    }

    $rangeInput.on('input', function () {
      sheet.textContent = getTrackStyle(this);
    });

    $rangeInput.on('mouseup', function () {
      storeStatus($(this).val(), $('#user_id').val());
    });

    $('.valid-until .button').on('click', function (e) {
      e.preventDefault();
      storeUntilDate();
    });

    sheet.textContent = getTrackStyle(document.querySelector('.user-status__input'));

    // Change input value on label click
    $('.user-status__labels li').on('click', function () {
      var index = $(this).index();

      $rangeInput.val(index + 1).trigger('input');

    });

  }
});
